var map = {
	"./example.svg": 30978,
	"./eye.svg": 97591,
	"./form.svg": 57610,
	"./home.svg": 82589,
	"./login-mall.svg": 43286,
	"./marker.svg": 26782,
	"./order-return-reason.svg": 11060,
	"./order-return.svg": 81087,
	"./order-setting.svg": 63383,
	"./order.svg": 25472,
	"./password.svg": 20731,
	"./product-add.svg": 91527,
	"./product-attr.svg": 3367,
	"./product-brand.svg": 98657,
	"./product-cate.svg": 88671,
	"./product-comment.svg": 85153,
	"./product-list.svg": 47894,
	"./product-recycle.svg": 37929,
	"./product.svg": 82053,
	"./sms-ad.svg": 44951,
	"./sms-coupon.svg": 33582,
	"./sms-flash.svg": 75630,
	"./sms-hot.svg": 25545,
	"./sms-new.svg": 89282,
	"./sms-subject.svg": 93968,
	"./sms.svg": 58223,
	"./table.svg": 19212,
	"./total-today.svg": 37522,
	"./total-week.svg": 66063,
	"./total-yesterday.svg": 5261,
	"./tree.svg": 91024,
	"./ums-admin.svg": 75175,
	"./ums-menu.svg": 92251,
	"./ums-resource.svg": 67218,
	"./ums-role.svg": 89330,
	"./ums.svg": 65861,
	"./user.svg": 80681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;